import { Helmet } from 'react-helmet-async';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box } from '@mui/material';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import './common.scss';
// ----------------------------------------------------------------------

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function CreateCampaignPage() {
  return (
    <>
      <Helmet>
        <title> Create User | Ckers </title>
      </Helmet>

      <Container>
        <Typography variant="h4" sx={{ mb: 5 }}>
            Create Campaign
        </Typography>
            <div id='main-wrap'>
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='form-group'>
                            <label htmlFor="campaign-name">
                                <span>Campaign Name</span>
                                <input type='text' id='campaign-name' className='form-control' />
                            </label>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <label htmlFor="source-of-lead">
                                <span>Source of Lead</span>
                                <select id='source-of-lead' className="form-select">
                                    <option selected>Select Source of Lead</option>
                                    <option value="1">One</option>
                                    <option value="2">Two</option>
                                    <option value="3">Three</option>
                                </select>
                            </label>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='form-group'>
                            <label htmlFor="assign-to">
                                <span>Assign to</span>
                                <select id='assign-to' className="form-select">
                                    <option selected>Select User</option>
                                    <option value="1">One</option>
                                    <option value="2">Two</option>
                                    <option value="3">Three</option>
                                </select>
                            </label>
                        </div>
                    </div>
                    <div className='col-md-3'>
                        <div className='form-group'>
                            <div className="form-check form-switch">
                                <label className="form-check-label" htmlFor="is-active">
                                    <input className="form-check-input" type="checkbox" role="switch" id="is-active" />
                                    <span>Is Active</span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-12'>
                        <div className='form-group mb-2'>
                            <button className='btn btn-primary'>Submit</button>
                        </div>
                    </div>
                </div>
            </div>
      </Container>
    </>
  );
}